export default __webpack_public_path__ + "static/media/wv-header-background.0a780a5b.png";